
import { ref, computed } from 'vue';
import { addTableScrollListener } from '@/views/productDaily/serve/getTableScroll';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import store from '@/store/index';

export default {
  setup() {
    const flex = require('@/utils/base/flexible');
    const loading = computed(() => store.getters.load);
    const checkisMobile = () => {
      const isMobile = window.screen.width < 1024;
      store.commit('SET_MOBILE', isMobile);
    };
    const getScreenWidth = () => {
      const { offsetWidth, offsetHeight } = document.body;
      store.commit('SET_SCREEN_WIDTH', { offsetWidth, offsetHeight });
    };
    checkisMobile();
    window.onresize = () => {
      // addTableScrollListener();
      getScreenWidth();
    };
    return {
      zhCN,
      loading,
    };
  },
};
